<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex flex-col sm:flex-row gap-2">
            <div class="relative">
                <input type="text" [(ngModel)]="search" (ngModelChange)="onSearch($event)" placeholder="Search.." class="pl-8" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
            </div>
            <div>
                <select (change)="onSelectStatus($event)" id="inputStatus" class="min-w-40">
                    <option [value]="true">Active</option>
                    <option [value]="false">Inactive</option>
                </select>

            </div>
            <div class="min-w-40 sm:min-w-44">
                <ng-select [(ngModel)]="selectedFundingSource" (change)="onFundingSourceChange()" [clearable]="false"
                    [searchable]="true" >
                    <ng-option value="">Select FS</ng-option>
                    <ng-option *ngFor="let fundingsource of fundingSources" [value]="fundingsource.id">
                    {{ fundingsource.title | titlecase }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="min-w-40 sm:min-w-44">
                <ng-select [(ngModel)]="selectedMemberType" (change)="onMemberTypeChange()" [clearable]="false"
                    [searchable]="false">
                    <ng-option value="">Select Member Type</ng-option>
                    <ng-option value="standard">Standard</ng-option>
                    <ng-option value="private_pay">Private Pay</ng-option>
                    <ng-option value="self">Self</ng-option>
                </ng-select>
            </div>
        </div>
        
        <div *ngIf="members && members.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(numberOfRecords * currentPage) - (members != numberOfRecords? (numberOfRecords
                -members.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div class="flex flex-col sm:flex-row gap-2">
            
            <button type="button" class="btn btn-primary text-xs" (click)="downloadMemberCSV()">
                Download CSV
            </button>
                <button routerLink="add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_MEMBER])"
                    class="btn btn-secondary">
                    Add
                </button>
            <div *ngIf="selectedMembers && selectedMembers.length" class="relative inline-block text-left" (outsideClick)="closeFilterDropDown($event)" outside-click>
                <div>
                    <button type="button" (click)="toggleDropdown($event)" class="btn btn-secondary" id="menu-button"
                        aria-expanded="true" aria-haspopup="true">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="size-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
                        </svg>
                        <!-- <span *ngIf="( selectedCorporateUser &&  selectedCorporateUser.length > 0)"
                            class="flex absolute h-3 w-3 -top-1 -right-1">
                            <span class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-red-500"></span>
                            <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                        </span> -->
                    </button>
                </div>
                <div *ngIf="isDropdownOpen"
                    class="absolute right-0 z-50 mt-2 w-72 origin-top-right rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                    role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                    <div class="p-3 grid grid-cols-2 gap-2" role="none">
                        <div class="sm:col-span-2 mt-2" role="menuitem" tabindex="-1" id="menu-item-1">
                            <div class="p-1 grid grid-cols-1 gap-1">
                                <button *ngIf="selectedMembers && selectedMembers.length" type="button" class="btn btn-primary text-xs"
                                    (click)="openMergeModal()">
                                    Merge
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedMembers && selectedMembers.length " class="w-44 rounded-xl bg-gray-200 dark:bg-zinc-950 px-2 py-2">
        <dl class="flex items-center">
            <dt class="grid place-content-center flex-shrink-0 rounded-lg bg-main-base">
                <svg class="h-8 w-8 text-main-primary" fill="currentColor" viewBox="0 0 24 24" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
                        <g fill="currentColor" fill-rule="nonzero">
                            <path
                                d="M20.4961766,5.62668182 C21.3720675,5.93447702 22,6.76890777 22,7.75 L22,17.75 C22,20.0972102 20.0972102,22 17.75,22 L7.75,22 C6.76890777,22 5.93447702,21.3720675 5.62668182,20.4961766 L7.72396188,20.4995565 L17.75,20.5 C19.2687831,20.5 20.5,19.2687831 20.5,17.75 L20.5,7.75 L20.4960194,7.69901943 L20.4961766,5.62668182 Z M17.246813,2 C18.4894537,2 19.496813,3.00735931 19.496813,4.25 L19.496813,17.246813 C19.496813,18.4894537 18.4894537,19.496813 17.246813,19.496813 L4.25,19.496813 C3.00735931,19.496813 2,18.4894537 2,17.246813 L2,4.25 C2,3.00735931 3.00735931,2 4.25,2 L17.246813,2 Z M13.4696699,7.46966991 L9.58114564,11.3581942 L8.6,10.05 C8.35147186,9.71862915 7.88137085,9.65147186 7.55,9.9 C7.21862915,10.1485281 7.15147186,10.6186292 7.4,10.95 L8.9,12.95 C9.17384721,13.3151296 9.70759806,13.3530621 10.0303301,13.0303301 L14.5303301,8.53033009 C14.8232233,8.23743687 14.8232233,7.76256313 14.5303301,7.46966991 C14.2374369,7.1767767 13.7625631,7.1767767 13.4696699,7.46966991 Z">
                            </path>
                        </g>
                    </g>
                </svg>
            </dt>
            <dd class="w-full ml-4 truncate text-right">
                <div class="text-xs text-main-light flex-1 "> Selected Members </div>
                <div class="text-sm font-bold text-main-secondary flex-1 truncate">{{selectedMembers.length}}</div>
            </dd>
        </dl>
    </div>

    <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="overflow-x-auto h-full">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead class=" sticky top-0 z-10">
                                <tr>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <!-- <input type="checkbox" [checked]="selectedMembers.length && selectedMembers.length === members.length"
                                            (change)="onSelectAllMembers($event)" /> -->
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Name</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Contact No.
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Address
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Gender</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Member Type
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Payment Type
                                    </th>
            
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Email
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Funding Source
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Created At
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Updated At
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Payment Status
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                    *ngFor="let member of members | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems:totalResults }; let i=index" [ngClass]="{'bg-gray-950/5 dark:bg-white/10': member.isSelected}">
                                     <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                       {{i+1}}
                                    </td>
                                    <td *ngIf="permissionService.hasPermission([userPermission.MANAGE_MEMBER])"
                                        class="relative px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <!-- Selected row marker, only show when row is selected. -->
                                        <div class="absolute inset-y-0 left-0 w-0.5 bg-main-primary"
                                            [ngClass]="{'hidden': !member.isSelected}">
                                        </div>
                                        <input (click)="onSelectMember(member)" type="checkbox" [(ngModel)]="member.isSelected" type="checkbox"/>
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex" >
                                            <button  [appToolTip]="'Detail'" (click)="opendetailModal(member)" class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400 border-r border-zinc-300 px-2">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                                  stroke="currentColor" class="w-5 h-5">
                                                  <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                              </button>
            
                                            <button [appToolTip]="'Edit'" (click)="openMemberEditModal(member)" 
                                            *ngIf="permissionService.hasPermission([userPermission.MANAGE_MEMBER])"
                                            class="border-zinc-300 px-2 ">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor"
                                                    class="size-5 text-zinc-500 dark:text-zinc-400 hover:text-zinc-950 dark:hover:text-white">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                                </svg>
                                            </button>
                                            <button [appToolTip]="'Member Trips'" *ngIf="permissionService.hasPermission([userPermission.GET_MEMBER_TRIP])" (click)="memberTrips(member)" class="border-zinc-300 px-2 border-l">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="size-5 text-zinc-500 dark:text-zinc-400 hover:text-zinc-950 dark:hover:text-white"
                                                    viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                                                    <path fill="currentColor"
                                                        d="M9 21q-1.65 0-2.825-1.175T5 17V8.825Q4.125 8.5 3.563 7.738T3 6q0-1.25.875-2.125T6 3t2.125.875T9 6q0 .975-.562 1.738T7 8.825V17q0 .825.588 1.413T9 19t1.413-.587T11 17V7q0-1.65 1.175-2.825T15 3t2.825 1.175T19 7v8.175q.875.325 1.438 1.088T21 18q0 1.25-.875 2.125T18 21t-2.125-.875T15 18q0-.975.563-1.75T17 15.175V7q0-.825-.587-1.412T15 5t-1.412.588T13 7v10q0 1.65-1.175 2.825T9 21" />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(member.displayName | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="member?.contactNumber">
                                        {{member.contactNumber || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{member?.address?.name || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(member?.gender | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(member?.memberType | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(member?.paymentType | titlecase) || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{member?.email || 'N/A'}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span *ngIf="member?.fundingsource && preFundingSource?.[member.fundingsource]; else typeNotFound">
                                            {{ (preFundingSource[member.fundingsource].title | titlecase) }}
                                        </span>
                                        <ng-template #typeNotFound>N/A</ng-template>
                                    
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(member.createdAt |date:'MM/DD/YYYY') || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(member.updatedAt |date:'MM/DD/YYYY') || 'N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="member.squareCustomer ? 'badge-success':'badge-danger'">
                                            {{member.squareCustomer ? 'Enabled' : 'Disabled'}}
                                        </span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="member.isActive ? 'badge-success':'badge-danger'">{{member.isActive ?
                                            'Active' :
                                            'Inactive'}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="flex justify-between items-center py-2">
            <div class="flex items-center gap-2 text-xs text-zinc-600 dark:text-zinc-400">
                <span>Items per page</span>
                <div class="relative inline-block text-left" (outsideClick)="closeItemsPerPageDropdown()" outside-click>
                    <button
                        type="button"
                        (click)="toggleItemsPerPageDropdown($event)"
                        class="inline-flex items-center justify-between gap-x-1.5 rounded-md bg-white dark:bg-zinc-900 px-2.5 py-1 text-xs font-medium text-zinc-900 dark:text-zinc-100 shadow-sm border border-zinc-950/10 dark:border-white/10 hover:bg-zinc-50 dark:hover:bg-zinc-800 focus:outline-none"
                        aria-expanded="false"
                        aria-haspopup="true">
                        <span>{{ numberOfRecords }}</span>
                        <svg
                            class="-mr-0.5 h-3.5 w-3.5 text-zinc-500 dark:text-zinc-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isItemsPerPageOpen}"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true">
                            <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
                        </svg>
                    </button>

                    <div
                        *ngIf="isItemsPerPageOpen"
                        class="absolute bottom-full left-0 z-50 mb-1.5 w-24 origin-bottom-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 dark:border-white/10 py-1 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical">
                        <button
                            *ngFor="let option of pageSizeOptions"
                            type="button"
                            (click)="onLimitChange(option)"
                            class="w-full text-left px-3 py-1.5 text-xs transition-colors flex items-center justify-between"
                            [ngClass]="{
                                'bg-zinc-100 dark:bg-zinc-800 text-primary font-semibold': numberOfRecords === option,
                                'text-zinc-700 dark:text-zinc-300 hover:bg-zinc-50 dark:hover:bg-zinc-800/60': numberOfRecords !== option
                            }"
                            role="menuitem">
                            <span>{{ option }}</span>
                            <svg *ngIf="numberOfRecords === option" class="h-3.5 w-3.5 text-primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>


<app-member-trips-modal *ngIf="memberDetail" [memberDetails]="memberDetail"
    (closeModal)="memberDetail = null"></app-member-trips-modal>
<app-member-detail-modal *ngIf="memberData" [memberDetailsObj]="memberData"
    (closeModal)="memberData = null"></app-member-detail-modal>

<app-member-wrapper *ngIf="editMemberObj" [memberId]="editMemberObj.id" [source]="'memberlist'" (onSave)="onSaveMember($event)"
    (onCloseModal)="editMemberObj = false"></app-member-wrapper>
<app-member-merge-modal *ngIf="mergeModalObj" [members]="mergeModalObj" (closeModal)="onCloseMergeModal($event)"></app-member-merge-modal>